export enum ComponentState {
    ready = 0,
    confirmation = 1,
    loading = 2,
    error = 3,
    success = 4,
    empty = 5,
}

export enum UserType {
    Patient = 0,
    PatientRep = 1,
    HCP = 2,
    Pharmacist = 3,
}

export enum CommunicationTypes {
    "None" = 0,
    "Phone" = 8,
    "Letter|Phone" = 9,
    "Email|Phone" = 10,
    "Letter|Email|Phone" = 11
}

export enum CommunicationTypesQP {
    'None' = 0,
    'Email' = 5,
    'Mail' = 13,

    // in case of mail and email we have contact preference array size > 1
    // thus for indication we kept the value 2
    'Email|Mail' = 2,
}

export enum ProgramState {
    Gilead = 100,
    Vemlidy = 1,
    AdvancingAccess = 2,
    Epclusa = 3,
    Harvoni = 4,
    Vosevi = 5,
    Sovaldi = 6,
    GenericEpclusa = 7,
    GenericHarvoni = 8,
}

export const ProgramVariables = [
    {
        ProgramName: 'Trodelvy',
        ProgramTitle: 'Trodelvy',
        ProgramState: ProgramState.Gilead,
        CompanyTitle: 'Gilead',
        PatientProgramId: 351,
        PatientRepProgramId: 335,
        HcpProgramId: 352,
        PharmacyProgramId: 353,
        Survey: {
            SurveyId: 1034,
            userIdentityAnswer: {
                questionId: 35908,
                patientAnswerId: 59119,
                patientRepAnswerId: 59120,
                hcpAnswerId: 59121,
                pharmacyAnswerId: 59122,
            },
            usaResidentAnswer: {
                questionId: 35909,
                answerYesId: 59125,
                answerNoId: 59126,
            },
            federalProgramAnswer: {
                questionId: 35910,
                answerYesId: 59123,
                answerNoId: 59124,
            },
            prescriptionBenefitsAnswer: {
                questionId: 35911,
                answerYesId: 59127,
                answerNoId: 59128,
            },
            termsAnswer: {
                questionId: 35912,
                answerYesId: 59129,
            },
            underageConsent: {
                questionId: 22325,
                answerYesId: 17405,
            },
            offerConsent: {
                questionId: 22289,
                answerYesId: 17324,
            },
        },
    },
];
